// 新增关键字
import fetch from '@/plugin/axios'

// 获取列表
export function getList (data) {
  return fetch({
    url: '/api/order/service-project/list',
    method: 'Post',
    data: data
  })
}

// 获取列表
export function getProjectInfo (id) {
  return fetch({
    url: `/api/order/service-project/${id}`,
    method: 'Get'
  })
}

// 选择交付资源
export function selectSource (id) {
  return fetch({
    url: `/api/order/service-project-source/select/${id}`,
    method: 'Post'
  })
}
// 从文件库进行交付
export function selectSourceForFile (id, data) {
  return fetch({
    url: `/api/order/service-project-source/select/for_resource/${id}`,
    method: 'Post',
    data: data
  })
}
export function addContentForFile (id, data) {
  return fetch({
    url: `/api/order/service-project-source/select/for_resource/content/${id}`,
    method: 'Post',
    data: data
  })
}
// 交付资源列表
export function getSourceList (id) {
  return fetch({
    url: `/api/order/service-project-source/list/${id}`,
    method: 'Get'
  })
}

export function getContentList (id) {
  return fetch({
    url: `/api/order/service-project-source-content/list/${id}`,
    method: 'Get'
  })
}

export function getSourcePage (data) {
  return fetch({
    url: `/api/order/service-project-source/list`,
    method: 'Post',
    data: data
  })
}

export function editSourceBaseInfo (id, data) {
  return fetch({
    url: `/api/order/service-project-source/update/base_info/${id}`,
    method: 'Post',
    data: data
  })
}

export function addRemark (id, remark) {
  return fetch({
    url: `/api/order/service-project/remark`,
    method: 'Put',
    data: { 'id': id, 'remark': remark }
  })
}

export function commitProject (id) {
  return fetch({
    url: `/api/order/service-project/commit/${id}`,
    method: 'Get'
  })
}

// 新增项目
export function addProject (data) {
  return fetch({
    url: `/api/order/service-project/add`,
    method: 'Post',
    data: data
  })
}
// 修改项目
export function updateProject (id, data) {
  return fetch({
    url: `/api/order/service-project/edit/${id}`,
    method: 'Post',
    data: data
  })
}

// 或去项目信息
export function updateProjectInfo (id) {
  return fetch({
    url: `/api/order/service-project/info/${id}`,
    method: 'Get'
  })
}

// 自动生成岗位
export function autoCreatePosition (industryId, notes) {
  return fetch({
    url: `/api/order/service-project/auto-create-items/${industryId}`,
    method: 'post',
    data: { data: notes }
  })
}

// 自动生成步骤
export function autoCreateTask (description) {
  return fetch({
    url: `/api/order/service-project/auto-create-task`,
    method: 'post',
    data: { data: description }
  })
}

// 分享项目
export function shareProject (data) {
  return fetch({
    url: `/api/order/service-project/project/share`,
    method: 'post',
    data: data
  })
}

//  获取工作流列表
export function getWorkflowList (data) {
  return fetch({
    url: `/api/common/comfyui-workflow/list`,
    method: 'get',
    data: data
  })
}

// 工作流执行
export function executeWorkflow (id, themeId, data) {
  return fetch({
    url: `/api/common/comfyui-workflow/draw/${id}?themeId=${themeId}`,
    method: 'post',
    data: data
  })
}

export function getWorkflowInfo (id, serverId) {
  return fetch({
    url: `/api/common/comfyui-workflow/history/${id}?serverId=${serverId}`,
    method: 'get'
  })
}

// lora列表
export function getLoraList () {
  return fetch({
    url: `/api/common/comfyui-workflow/lora/list`,
    method: 'get'
  })
}

// checkpoint列表
export function getCheckpointList () {
  return fetch({
    url: `/api/common/comfyui-workflow/checkpoint/list`,
    method: 'get'
  })
}

// vae列表
export function getVaeList () {
  return fetch({
    url: `/api/common/comfyui-workflow/vae/list`,
    method: 'get'
  })
}
// sampler_name列表
export function getSamplerNameList () {
  return fetch({
    url: `/api/common/comfyui-workflow/sampler_name/list`,
    method: 'get'
  })
}

// scheduler列表
export function getSchedulerList () {
  return fetch({
    url: `/api/common/comfyui-workflow/scheduler/list`,
    method: 'get'
  })
}

// weight_type 列表
export function getWeightTypeList () {
  return fetch({
    url: `/api/common/comfyui-workflow/weight_type/list`,
    method: 'get'
  })
}

// 添加工作流主题
export function addWorkflowTheme (data) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/add`,
    method: 'post',
    data: data
  })
}

// 更新工作流主题
export function updateWorkflowTheme (id, data) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/${id}`,
    method: 'post',
    data: data
  })
}

// 上架主题
export function upWorkflowTheme (id) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/up/${id}`,
    method: 'post'
  })
}

// 下架主题
export function downWorkflowTheme (id) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/down/${id}`,
    method: 'post'
  })
}

// 删除
export function deleteWorkflowTheme (id) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/${id}`,
    method: 'delete'
  })
}

// 审核主题
export function auditWorkflowTheme (id, auditStatus) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/audit/${id}`,
    method: 'post',
    params: {
      auditStatus: auditStatus
    }
  })
}

// 分类选项列表
export function getWorkflowThemeCategoryOptions () {
  return fetch({
    url: `/api/common/comfyui-theme-classify/options`,
    method: 'get'
  })
}

// 主题列表
export function getWorkflowThemeList (data) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/list`,
    method: 'post',
    data: data
  })
}

// 主题分类列表
export function getWorkflowThemeCategoryList (data) {
  return fetch({
    url: `/api/common/comfyui-theme-classify/list`,
    method: 'post',
    data: data
  })
}

// 更新主题分类
export function updateWorkflowThemeCategory (data) {
  return fetch({
    url: `/api/common/comfyui-theme-classify/update`,
    method: 'post',
    data: data
  })
}

// 添加主题分类
export function addWorkflowThemeCategory (data) {
  return fetch({
    url: `/api/common/comfyui-theme-classify/add`,
    method: 'post',
    data: data
  })
}

// 上架主题分类
export function upWorkflowThemeCategory (id) {
  return fetch({
    url: `/api/common/comfyui-theme-classify/up/${id}`,
    method: 'post'
  })
}

// 下架主题分类
export function downWorkflowThemeCategory (id) {
  return fetch({
    url: `/api/common/comfyui-theme-classify/down/${id}`,
    method: 'post'
  })
}

// 获取主题信息
export function getWorkflowThemeInfo (id) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/info/${id}`,
    method: 'get'
  })
}

// 获取队列信息
export function getQueueInfo (id) {
  return fetch({
    url: `/api/common/comfyui-workflow/comfui/queue//${id}`,
    method: 'get'
  })
}

// 删除指定队列
export function deleteQueue (serverId, promptIds) {
  return fetch({
    url: `/api/common/comfyui-workflow/remove/${serverId}`,
    method: 'post',
    data: promptIds
  })
}

// 获取人像
export function getPortrait (data) {
  return fetch({
    url: `/api/common/comfyui-person/list`,
    method: 'get',
    data: data
  })
}

export function getPortraitPage (data) {
  return fetch({
    url: `/api/common/comfyui-person/page`,
    method: 'post',
    data: data
  })
}

// 添加人像
export function addPortrait (data) {
  return fetch({
    url: `/api/common/comfyui-person/add`,
    method: 'post',
    data: data
  })
}

// 更新人像
export function updatePortrait (id, data) {
  return fetch({
    url: `/api/common/comfyui-person/update${id}`,
    method: 'post',
    data: data
  })
}

// 删除人像
export function deletePortrait (id) {
  return fetch({
    url: `/api/common/comfyui-person/delete/${id}`,
    method: 'delete'
  })
}

// 批量添加主题
export function batchAddWorkflowTheme (data) {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/batch-add`,
    method: 'post',
    data: data
  })
}
// 主题级联选择
export function getWorkflowThemeCascader () {
  return fetch({
    url: `/api/common/comfyui-workflow-theme/cascader`,
    method: 'get'
  })
}

// 添加aigc任务
export function addAigcTask (data) {
  return fetch({
    url: `/api/common/comfyui-task/add`,
    method: 'post',
    data: data
  })
}

// 获取aigc任务列表
export function getAigcTaskList (data) {
  return fetch({
    url: `/api/common/comfyui-task/list`,
    method: 'post',
    data: data
  })
}

// 获取aigc任务信息
export function getAigcTaskInfo (id) {
  return fetch({
    url: `/api/common/comfyui-task/detail/${id}`,
    method: 'get'
  })
}

// 获取任务状态
export function getAigcTaskStatus (id) {
  return fetch({
    url: `/api/common/comfyui-task/status/${id}`,
    method: 'get'
  })
}

// 打包下载结果 二进制数据
export function downloadAigcTaskResult (id) {
  return fetch({
    url: `/api/common/comfyui-task/download/${id}`,
    method: 'get',
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/zip'
    }
  })
}

// 新增项目(通过agent)
export function addProjectByAgent (data) {
  return fetch({
    url: `/api/order/service-project/add/agent`,
    method: 'post',
    data: data
  })
}

// 项目信息 agent
export function getProjectInfoByAgent (id) {
  return fetch({
    url: `/api/order/service-project/info/agent/${id}`,
    method: 'get'
  })
}

// 获取项目item 状态
export function getProjectItemStatus (id) {
  return fetch({
    url: `/api/order/service-project-item/status/${id}`,
    method: 'get'
  })
}
